// @ts-nocheck
// Note: Recharts has type incompatibilities with React 18/19. Suppressing type checks for this
// file, exactly as StageTrendChart.tsx and components/common/MonthlyBreakdownChart.tsx do.
import React, { useRef } from 'react';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { ViewportChartTooltip } from './chartTooltip';
import { CHART_AXIS_TICK, CHART_GRID, chartColour, hexRgb } from './trackerKit';

/**
 * One metric, by month, one line per broker. Single axis, never dual-axis (V6 design).
 *
 * House chart style (trackerKit): CHART_GRID, CHART_AXIS_TICK, broker lines from CHART_PALETTE,
 * the dark tooltip card, and a card with the metric's accent bar. Counts only; no money here.
 *
 * `accent` colours the card's top edge and title dot, one per metric, so the three charts are told
 * apart at a glance; the lines keep the broker colours.
 *
 * The tooltip is centred on the chart's height and clamped to the viewport (chartTooltip.tsx): with
 * every broker listed, a card that followed the cursor ran off the bottom of the page.
 */
const EfficiencyChart = ({ title, rows, series, accent = '#3b82f6' }) => {
  const plotRef = useRef(null);
  return (
    <div
      className="relative overflow-hidden rounded-lg border bg-gray-900/30 p-3 pt-4"
      style={{ borderColor: `rgba(${hexRgb(accent)},0.3)` }}
    >
      <div aria-hidden="true" className="absolute inset-x-0 top-0 h-[0.1875rem]" style={{ background: accent }} />
      <h4 className="mb-2 flex items-center gap-2 text-xs font-semibold text-gray-200">
        <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{ background: accent }} />
        {title}
      </h4>
      <div className="h-44" ref={plotRef}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={rows} margin={{ top: 6, right: 8, left: -18, bottom: 0 }}>
            <CartesianGrid {...CHART_GRID} />
            <XAxis dataKey="month" tick={CHART_AXIS_TICK} interval={1} />
            <YAxis allowDecimals={false} tick={CHART_AXIS_TICK} />
            <Tooltip
              content={<ViewportChartTooltip containerRef={plotRef} />}
              cursor={{ stroke: '#475569', strokeDasharray: '3 3' }}
              isAnimationActive={false}
            />
            {series.map((s, i) => (
              <Line
                key={s.key}
                type="monotone"
                dataKey={`s${i}`}
                name={s.name}
                stroke={chartColour(i)}
                strokeWidth={2}
                dot={false}
                activeDot={{ r: 4, strokeWidth: 0 }}
                isAnimationActive={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EfficiencyChart;
